import React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { SectionHeader } from '../common/SharedComponents';

function BorrowersLanding() {
    const styles = {
        linkPaper: {
            color: '#2C5591',
            textAlign: 'center' as const,
            padding: 50,
            fontSize: 14,
            margin: 20,
            width: 300,
        },
        loginPaper: {
            color: '#2C5591',
            padding: 20,
            fontSize: 14,
            margin: 20,
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row' as const,
            justifyContent: 'space-evenly' as const,
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <SectionHeader title='Applications' />
            <div
                className='row scrollable-content'
                style={styles.flexContainer}
            >
                <Link
                    to='/borrowers/active'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>By Business</h1>
                        <p>Manage Businesses, Entities, & Principals. Organized by Business.</p>
                    </Paper>
                </Link>
                <Link
                    to='/borrowers/recyclebin'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>Recycle Bin</h1>
                        <p>Manage Deleted Businesses, Entities and Principals.</p>
                    </Paper>
                </Link>
            </div>
        </>
    );
}

export default BorrowersLanding;
